import { useEffect, useState } from "react";
import Switch from "../Switch";

const FilterOrdersCheckbox = ({ pullback, defaultValue = true }) => {

    const [value, setValue] = useState(defaultValue)

    useEffect(() => setValue(defaultValue), [defaultValue])
    useEffect(() => pullback(value), [value])


    return (
        <div className="flexRow xdfe633" style={{ background: '#fff', border: '1px solid #ccc', padding: '7px 15px', borderRadius: '.25rem', }}>
            <Switch value={value} onClick={setValue} label='نمایش جزئیات' />
        </div>
    );
}

export default FilterOrdersCheckbox;